export const DEFAULT_TRADE_LOCALE = 'de-DE';
